import { Injectable } from '@angular/core';
import { ToolsService } from '../services/tools.service';
import { Translation } from '@3ddv/ngx-sites-builder-lib';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  public tempFile: File;

  constructor() {}

  public saveTempFile(file) {
    this.tempFile = file;
  }

  public getTempFile() {
    return this.tempFile;
  }

  // Adds or overwrites customData to tool.data
  public addCustomData(tool: Translation) {
    // console.log('tool (service)', tool);
    
    if (tool.data) {
      // To update view list
      tool.data = JSON.parse(JSON.stringify(tool.data));
    } else {
      tool.data = {};
    }

    // Check and add/overwrites data
    for (const key in tool.customData) {
      tool.data[key] = tool.customData[key];
    }

    // Si el objeto customData está vacío
    if (tool.customData && Object.keys(tool.customData).length === 0) {
      tool.customData = null;
    }
    // Si el objeto data está vacío
    if (tool.data && Object.keys(tool.data).length === 0) {
      tool.data = null;
    }

    return tool;
  }
}







// // To update data and list
// // if (Object.keys(tool.data).length !== 0) {
// if (tool.data) {
//   tool.data = JSON.parse(JSON.stringify(tool.data));

//   // Si existe tool.data y tool.customData
//   // if (Object.keys(tool.customData).length !== 0) {
//   if (tool.customData) {
//     // Check and add/overwrites data
//     for (const key in tool.customData) {
//       tool.data[key] = tool.customData[key];
//     }
//   // SÍ existe tool.data pero NO existe tool.customData
//   } else {
//     tool.customData = null;
//   }

// } else {
//   tool.data = null;
  
//   // Si NO existe tool.data pero SÍ tool.customData
//   if (Object.keys(tool.customData).length !== 0) {
//     tool.data = {};
//     // Check and add/overwrites data
//     for (const key in tool.customData) {
//       tool.data[key] = tool.customData[key];
//     }
//   // Si NO existe tool.customData NI tool.data
//   } else {
//     tool.customData = null;
//   }

// }